var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-input-icon",class:'kt-input-icon--'+_vm.align},[_vm._t("default"),_c('span',{staticClass:"kt-input-icon__icon",class:'kt-input-icon__icon--'+_vm.align},[_c('span',[_c('kt-icon',{attrs:{"...icon":""}})],1)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }